'use strict';

var React = require('react');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);

function SvgTimerCircle(props) {
    return (React__default.default.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", ...props },
        React__default.default.createElement("g", { fill: "none", fillRule: "evenodd" },
            React__default.default.createElement("path", { d: "M0 0h16v16H0z" }),
            React__default.default.createElement("path", { d: "M2 2h12v12H2z" }),
            React__default.default.createElement("path", { d: "M8 14c3.313 0 6-2.694 6-6s-2.687-6-5.993-6c-.4 0-.655.248-.655.64v2.003c0 .35.248.612.59.612.35 0 .59-.262.59-.612V3.371c2.286.27 4.097 2.27 4.097 4.629 0 2.527-2.088 4.629-4.629 4.629-2.541 0-4.629-2.102-4.629-4.629.008-1.041.396-2.038.986-2.803.27-.371.337-.721.024-1.027-.298-.291-.786-.255-1.1.16A5.955 5.955 0 002 8c0 3.306 2.694 6 6 6zm.954-4.995c.502-.524.4-1.253-.197-1.653l-2.825-1.9c-.408-.27-.786.116-.524.516l1.908 2.833c.4.597 1.128.706 1.638.204z", fill: "currentColor" }))));
}

module.exports = SvgTimerCircle;
//# sourceMappingURL=TimerCircle.js.map
